import PropTypes from 'prop-types';

import CustomIcon from '../../../CustomIcons';

import './styles/index.css';

const HamburguerIcon = ({ handleOpenDrawer, isGlobalNavExpanded }) => {
  const iconType = isGlobalNavExpanded ? 'mdClose' : 'menu';
  return (
    <div className="header__hamburguer flex-group">
      <button
        className="header__btn"
        type="button"
        tabIndex={0}
        onClick={handleOpenDrawer}
        aria-label="Click on hamburger button"
      >
        <CustomIcon type={iconType} className={`hamburger ${iconType}`} size="24" fill="#FFFFFF" />
      </button>
    </div>
  );
};

HamburguerIcon.propTypes = {
  handleOpenDrawer: PropTypes.func.isRequired,
  isGlobalNavExpanded: PropTypes.bool.isRequired
};

export default HamburguerIcon;
